import React from 'react';
import LocalizationManager from '../../../utils/localization/localization';

const ModernTeam = () => {
  const values = [
    {
      id: 'innovation',
      titleKey: 'teamValueInnovation',
      descriptionKey: 'teamValueInnovationDesc',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      id: 'collaboration',
      titleKey: 'teamValueCollaboration',
      descriptionKey: 'teamValueCollaborationDesc',
      color: 'from-green-500 to-emerald-500'
    },
    {
      id: 'excellence',
      titleKey: 'teamValueExcellence',
      descriptionKey: 'teamValueExcellenceDesc',
      color: 'from-red-500 to-pink-500'
    },
    {
      id: 'learning',
      titleKey: 'teamValueLearning',
      descriptionKey: 'teamValueLearningDesc',
      color: 'from-blue-500 to-purple-500'
    }
  ];

  return (
    <section id="team" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-dark-900">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-pink-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16 animate-slideUp">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            {LocalizationManager.t('teamTitle')}
          </h2>
          <p className="max-w-2xl mx-auto text-xl text-dark-300">
            {LocalizationManager.t('teamDescription')}
          </p>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div
              key={value.id}
              className="group glass p-8 rounded-2xl backdrop-blur-xl hover:backdrop-blur-2xl transition-all duration-500 cursor-pointer transform hover:scale-105 hover:-translate-y-2"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Gradient background on hover */}
              <div
                className={`absolute inset-0 bg-gradient-to-br ${value.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500 rounded-2xl pointer-events-none`}
              ></div>

              {/* Content */}
              <div className="relative z-10">
                {/* Title */}
                <h3 className="text-2xl font-bold text-white mb-4">{LocalizationManager.t(value.titleKey)}</h3>

                {/* Description */}
                <p className="text-dark-300 leading-relaxed">{LocalizationManager.t(value.descriptionKey)}</p>

                {/* Bottom accent */}
                <div
                  className={`mt-6 h-1 w-12 bg-gradient-to-r ${value.color} rounded-full group-hover:w-full transition-all duration-500`}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModernTeam;
